var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-label d-flex align-items-center text-center"},[_c('span',{class:_vm.eventClass},[_vm._v(_vm._s(_vm.event))])])}
var staticRenderFns = []

export { render, staticRenderFns }